import { useSignalR } from "../../../common/helpers/SignalR";
import { UpdatedTransactionNotification } from "../models/UpdatedTransactionNotification";

export const useUpdatedTransactionNotification = (callback: (notification: UpdatedTransactionNotification) => void) => useSignalR<UpdatedTransactionNotification>("UpdateTransaction", callback);
